import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';
import { GreyInput } from '../../components/inputs/greyInput';
import { minLengthValidator, maxLengthValidator } from '../../helpers/validators';
import { FormWrapper } from '../../styles/styled';
import Colors from '../../styles/colors';
import SubmitButton from './SubmitButton';
import TermsAgreement from './TermsAgreement';

class SignUpForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      termsAccepted: false,
    };
  }

  handleAgreement = () => {
    this.setState(({ termsAccepted }) => {
      return {
        termsAccepted: !termsAccepted,
      };
    });
  };

  render() {
    const {
      firstName,
      lastName,
      email,
      emailReadOnly = false,
      password,
      promoCode,
      modes,
      processing,
      error,
      onSignUp,
      onInputChange,
      fromFBSignIn,
      signInState,
      signInLink,
      submitBtnLabel,
      disabled,
    } = this.props;
    const { termsAccepted } = this.state;

    return (
      <FormWrapper>
        {modes.admin || modes.listenerDirectSignup && (
          <div className="row margin-five margin-fifteen-bottom">
            <div className="col-lg-12 center-col text-center">
              <div className="title-large">Let's get started!</div>
            </div>
          </div>
        )}
        {fromFBSignIn && (
          <div className="row">
            <div className="col-lg-12">
              <div className="alert alert-warning text-medium">
                We no longer support the Facebook Signup. In order to create an account, please fill
                up the informations below.
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <GreyInput
              placeholder={'First name'}
              onChange={onInputChange('firstName')}
              value={firstName}
              validators={[minLengthValidator.bind(null, 1)]}
              disabled={disabled}
            />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <GreyInput
              placeholder={'Last name'}
              onChange={onInputChange('lastName')}
              value={lastName}
              validators={[minLengthValidator.bind(null, 1)]}
              disabled={disabled}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <GreyInput
              type="email"
              placeholder={'Email'}
              onChange={onInputChange('email')}
              value={email}
              validators={[minLengthValidator.bind(null, 1)]}
              disabled={disabled}
              readOnly={emailReadOnly}
            />
            <GreyInput
              type="password"
              placeholder={'Password'}
              onChange={onInputChange('password')}
              onKeyPress={({ key }) => key === 'Enter' && onSignUp()}
              value={password}
              validators={[minLengthValidator.bind(null, 6)]}
              disabled={disabled}
            />
            {modes.special && (
              <GreyInput
                type="text"
                placeholder="Redemption code"
                onChange={onInputChange('promoCode')}
                value={promoCode}
                validators={[minLengthValidator.bind(null, 8), maxLengthValidator.bind(null, 12)]}
                disabled={disabled}
              />
            )}
            {!isEmpty(error) && (
              <div className="alert alert-danger text-medium text-left">{error}</div>
            )}
            <TermsAgreement accepted={termsAccepted} onChange={this.handleAgreement} />
            <SubmitButton
              loading={processing}
              onSignUp={onSignUp}
              label={submitBtnLabel}
              disabled={!termsAccepted || disabled}
            />
            {!!signInState && !emailReadOnly && (
              <SigninOption className="text-large font-italic">
                <span>Already have an account? </span>
                <Link
                  to={{
                    pathname: signInLink,
                    state: signInState,
                  }}>
                  {`Sign in >`}
                </Link>
              </SigninOption>
            )}
          </div>
        </div>
      </FormWrapper>
    );
  }
}

const SigninOption = styled.div`
  a {
    color: ${Colors.mainOrange};
  }
`;

SignUpForm.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  password: PropTypes.string,
  promoCode: PropTypes.string,
  processing: PropTypes.bool,
  error: PropTypes.any,
  onInputChange: PropTypes.func,
  onSignUp: PropTypes.func,
  modes: PropTypes.object,
  fromFBSignIn: PropTypes.bool,
  signInState: PropTypes.any,
  signInLink: PropTypes.string,
  submitBtnLabel: PropTypes.string,
  termsAccepted: PropTypes.bool,
  disabled: PropTypes.bool,
};

SignUpForm.defaultProps = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  promoCode: '',
  processing: false,
  onInputChange: () => () => {},
  onSignUp: () => {},
  modes: {
    admin: false,
    listener: false,
    special: false,
  },
  fromFBSignIn: false,
  signInState: {},
  signInLink: '/signin',
  submitBtnLabel: 'CREATE ACCOUNT',
  termsAccepted: true,
  disabled: false,
};

export default SignUpForm;
